const exemptionJSON = localStorage.getItem('geoipExemptionData')
let exemptionData = null
if(exemptionJSON) {
  exemptionData = JSON.parse(exemptionJSON)
}

// Caching variable to prevent duplicate fetch requests
let currentLocale = null

// Returns user locale via geoip
async function getLocale() {
  if(currentLocale) return currentLocale
  const res = await fetch('/browsing_context_suggestions.json')
  const { detected_values } = await res.json()
  currentLocale = detected_values.country.handle
  return currentLocale
}

function setExemptionData(isoCode = Shopify.country) {
  localStorage.setItem('geoipExemptionData', JSON.stringify({ date: Date.now(), isoCode }))
}

// Handle automatic redirection for user currency
async function attemptCurrencyRedirect() {
  if(!hasExemptionExpired()) return // No need to attempt a redirect if an exemption is still in place

  const userIsoCode = await getLocale()
  const currentIsoCode = Shopify.country

  if(userIsoCode === currentIsoCode) return // If store is already correct there's no need to redirect

  setExemptionData(userIsoCode)
  performRedirect(userIsoCode)
}

function hasExemptionExpired() {
  if(!exemptionData) return true

  const then = new Date(exemptionData.date)
  const now = new Date()
  const msBetweenDates = Math.abs(then.getTime() - now.getTime())
  const daysBetweenDates = msBetweenDates / (24 * 60 * 60 * 1000)
  if (daysBetweenDates < 30) return false
  return true
}

function shouldDisableGeoIP() {
  if(document.cookie.includes('GE_Replacement')) return true

  const urlSearchParams = new URLSearchParams(window.location.search)
  const params = Object.fromEntries(urlSearchParams.entries())

  if(params.hasOwnProperty('replacementExpire')) return true
  if(params.hasOwnProperty('startReplacement')) return true
  return false
}

async function handleDisableParam() {
  const urlSearchParams = new URLSearchParams(window.location.search)
  const params = Object.fromEntries(urlSearchParams.entries())

  if(params.hasOwnProperty('forceCountry')) {
    setExemptionData(params.forceCountry)
    return true
  }

  if(params.hasOwnProperty('disableGeoIP')) {
    setExemptionData(Shopify.country)
    return true
  }

  return false
}

function redirectToStoredCurrency() {
  // If the exemption has expired, skip this function
  if(hasExemptionExpired()) return
  const { isoCode } = exemptionData
  if(isoCode === Shopify.country) return // Already on correct store
  performRedirect(isoCode)
}

function operatedCountries(isoCode) {
  const operatedCountries = window.GLBE_PARAMS.operatedCountries;

  if(operatedCountries.includes(isoCode)) return

  // Forces a redirect to the US store
  localStorage.removeItem('geoipExemptionData')
  return true
}

function performRedirect(isoCode) {
  const form = document.querySelector('.country-picker form')
  document.querySelector('.country-picker input[name="language_code"], .country-picker input[name="country_code"]').value = isoCode
  if (form) form.submit()
}

;(async () => {
  return
  // Handle GeoIP disable query param
  const didUpdateExemptionData = await handleDisableParam()
  if(didUpdateExemptionData) return

  // Skip GeoIP system entirely if Global E dashboard query parameter is present
  if(shouldDisableGeoIP()) return

  redirectToStoredCurrency() // Step 1 - if a currency is already stored, use that
  await attemptCurrencyRedirect() // Step 2 - if no currency is stored and the user is on the correct store, attempt a GeoIP redirect
})()


class CountryPicker extends HTMLElement {
  constructor() {
    super();

    this.countryGroups = JSON.parse(document.getElementById('countryGroups').textContent);
    this.availableCountries = JSON.parse(document.getElementById('availableCountries').textContent);

    this.americaList = this.querySelector('#americas');
    this.europeList = this.querySelector('#europe');
    this.asiaList = this.querySelector('#asia');
    this.oceaniaList = this.querySelector('#oceania');
    this.middleList = this.querySelector('#middleEast');
    this.restList = this.querySelector('#rest');

    this.availableCountries.forEach((country) => {
      let newCountryLi = document.createElement('li');
      newCountryLi.setAttribute('data-name', country.country);
      let newCountryA = document.createElement('a');
      newCountryA.href = '#';
      newCountryA.setAttribute('data-value', country.code);
      if (country.code == this.querySelector('input[name="country_code"]').value){ newCountryA.setAttribute('aria-current','true') };
      newCountryA.innerHTML = country.country;
      newCountryLi.appendChild(newCountryA);

      const regionCheck = this.countryGroups.find(region => region.code == country.code);
      const regionFound = regionCheck != undefined ? regionCheck.group : 'rest';

      switch (regionFound) {
        case 'americas':
          this.americaList.appendChild(newCountryLi);
          break;
        case 'europe':
          this.europeList.appendChild(newCountryLi);
              break;
        case 'asia':
          this.asiaList.appendChild(newCountryLi);
          break;
        case 'oceania':
          this.oceaniaList.appendChild(newCountryLi);
          break;
        case 'middle':
          this.middleList.appendChild(newCountryLi);
          break;
        default:
          this.restList.appendChild(newCountryLi);
      }
    });

    this.querySelector('.country-picker-dimmer')?.addEventListener('click', e => {
      this.querySelector('.country-picker-modal').setAttribute('aria-hidden', true);
      this.querySelector('.country-picker-dimmer').setAttribute('aria-hidden', true);
      document.querySelectorAll('.offcanvas-header').forEach(item => item.style.display = '');
      document.querySelectorAll('.offcanvas-footer').forEach(item => item.style.display = '');
    })

    this.querySelector('.country-picker-close').addEventListener('click', e => {
      this.querySelector('.country-picker-modal').setAttribute('aria-hidden', true);
      this.querySelector('.country-picker-dimmer').setAttribute('aria-hidden', true);
      document.querySelectorAll('.offcanvas-header').forEach(item => item.style.display = '');
      document.querySelectorAll('.offcanvas-footer').forEach(item => item.style.display = '');
    })
    

    document.querySelectorAll('a[href="#nav-main-settings"]').forEach(item => item.addEventListener('click', e => {
      e.preventDefault();
      const countryPickerEl = this.querySelector('.country-picker-modal')
      const countryPickerDimmerEl = this.querySelector('.country-picker-dimmer')
    
      if (countryPickerEl) {countryPickerEl.setAttribute('aria-hidden', false);}
      if (countryPickerDimmerEl) {countryPickerDimmerEl.setAttribute('aria-hidden', false);}
      document.querySelectorAll('.offcanvas-header').forEach(item => item.style.display = 'none');
      document.querySelectorAll('.offcanvas-footer').forEach(item => item.style.display = 'none');
    }));

  }  
}
customElements.define('country-picker', CountryPicker);
  

class MarketPicker extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      input: this.querySelector('input[name="country_code"]'),
      countryListItems: this.querySelectorAll('li')
    }

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form')
    this.elements.input.value = event.currentTarget.dataset.value;
    localStorage.setItem('geoipExemptionData', JSON.stringify({date: Date.now(), isoCode: event.currentTarget.dataset.value}))

    if (form) 
      form.submit()
  }
}

customElements.define('market-picker', MarketPicker)


class LanguageSelect extends HTMLElement {
  constructor() {
    super();

    this.querySelector('.language-picker-dimmer')?.addEventListener('click', e => {
      this.querySelector('.language-picker').setAttribute('aria-hidden', true);
      this.querySelector('.language-picker-dimmer').setAttribute('aria-hidden', true);
      document.querySelectorAll('.offcanvas-header').forEach(item => item.style.display = '');
      document.querySelectorAll('.offcanvas-footer').forEach(item => item.style.display = '');
    })

    this.querySelector('.language-picker-close')?.addEventListener('click', e => {
      this.querySelector('.language-picker').setAttribute('aria-hidden', true);
      this.querySelector('.language-picker-dimmer').setAttribute('aria-hidden', true);
      document.querySelectorAll('.offcanvas-header').forEach(item => item.style.display = '');
      document.querySelectorAll('.offcanvas-footer').forEach(item => item.style.display = '');
    })
    
    this.querySelector('a[href="#nav-lang-settings"]')?.addEventListener('click', e => {
      e.preventDefault();
      const languagePickerEl = this.querySelector('.language-picker')
      const languagePickerDimmerEl = this.querySelector('.language-picker-dimmer')
    
      languagePickerEl.setAttribute('aria-hidden', false);
      languagePickerDimmerEl.setAttribute('aria-hidden', false);
      document.querySelectorAll('.offcanvas-header').forEach(item => item.style.display = 'none');
      document.querySelectorAll('.offcanvas-footer').forEach(item => item.style.display = 'none');
    })

  }  
}
customElements.define('language-select', LanguageSelect);


class LanguagePicker extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[name="language_code"]');
    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  onItemClick(event) {
    event.preventDefault()
    const form = this.querySelector('form');
    this.input.value = event.currentTarget.dataset.value;

    if (form) 
      form.submit()
  }
}

customElements.define('language-picker', LanguagePicker)
